/**
 * Identificação do contato nas telas da Mia (Conversas e Qualidade): nome,
 * telefone e avatar saem daqui para as duas mostrarem o mesmo cliente do
 * mesmo jeito — e o link para o cadastro apontar sempre para a mesma pessoa.
 */

const CORES_AVATAR = ['#00a884', '#7c3aed', '#0ea5e9', '#f59e0b', '#ef4444', '#ec4899', '#10b981', '#6366f1'];

/** Telefone legível: (84) 98190-9812 — sem DDI, com máscara de 10 ou 11 dígitos. */
export function formateTelefone(telefone: string): string {
  if (!telefone) return '';
  const digitos = telefone.replace(/\D/g, '').replace(/^55/, '');
  if (digitos.length === 11) return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
  if (digitos.length === 10) return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
  return telefone;
}

/**
 * Telefone no formato que a tela de contatos espera na URL. O wa_id do
 * WhatsApp vem sem o nono dígito nos celulares brasileiros; o cadastro guarda
 * com ele, então repomos antes de montar o link.
 */
export function telefoneDoContato(telefone: string): string {
  const digitos = String(telefone || '').replace(/\D/g, '');
  if (!digitos) return telefone;
  if (/^55\d{2}[6-9]\d{7}$/.test(digitos)) {
    return `+${digitos.slice(0, 4)}9${digitos.slice(4)}`;
  }
  return `+${digitos}`;
}

/** Nome do contato quando o WhatsApp mandou; senão o telefone formatado. */
export function nomeDoContato(nomeContato: string | null | undefined, telefone: string): string {
  return nomeContato || formateTelefone(telefone);
}

/** Iniciais do avatar: do nome quando há, senão os dois últimos dígitos. */
export function iniciaisDoContato(nomeContato: string | null | undefined, telefone: string): string {
  if (nomeContato) {
    const partes = nomeContato.trim().split(/\s+/);
    return (partes[0][0] + (partes[1]?.[0] || '')).toUpperCase();
  }
  const digitos = (telefone || '').replace(/\D/g, '');
  return digitos.slice(-2) || '?';
}

/** Cor estável do avatar — a mesma pessoa sai da mesma cor em qualquer tela. */
export function corDoAvatar(chaveBruta: string | number): string {
  const chave = String(chaveBruta || '');
  let hash = 0;
  for (let i = 0; i < chave.length; i++) hash = (hash * 31 + chave.charCodeAt(i)) >>> 0;
  return CORES_AVATAR[hash % CORES_AVATAR.length];
}
